module.exports = __webpack_public_path__ + "static/hd_logo-c9f8d6d5a896a08b2479a2d68bfea8af.png";